import React, { useState } from "react";

import { EnterpriseRole } from "@app/common/workspaces/types";

import ConfirmationModal from "@rui/ConfirmationModal";
import Dropdown, { DropdownMenuItem } from "@rui/Dropdown";
import { getSelectedFromOptions } from "@rui/Dropdown/utils";

import { WorkspaceSettingConfirmationModalProps } from "./types";

const OPTIONS = [
  {
    value: "admin",
    isDefault: true,
    label: "No, don't automatically share",
  },
  {
    value: "member",
    label: "Yes, automatically share",
  },
  {
    value: "manager",
    label: "Share only with Team Managers",
  },
];
const ShareTeamData = (props: WorkspaceSettingConfirmationModalProps) => {
  const [selected, setSelected] = useState<EnterpriseRole>(
    props.workspaceSettings.shareTeamDataView
  );

  const handleClose = () => {
    setSelected(props.workspaceSettings.shareTeamDataView);
    props.onClose();
  };
  const handleConfirm = () => {
    props.onConfirm(selected);
  };

  return (
    <ConfirmationModal
      title="Team report access"
      subtitle="Should people in a team automatically have access to everyone else's reports?"
      size="md"
      {...props}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <Dropdown
        name="share-team-data"
        selectedItem={getSelectedFromOptions(OPTIONS, selected)}
        onChange={(e) => setSelected(e.target.value as EnterpriseRole)}
      >
        {OPTIONS.map((item) => (
          <DropdownMenuItem
            key={item.value}
            {...item}
            selected={item.value === selected}
          />
        ))}
      </Dropdown>
    </ConfirmationModal>
  );
};

export default ShareTeamData;
